import { Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { environment } from '../../../../../environment/environment';
import { AuthService, DialogService } from '../../../../core/services';
import { AuthStore, NavbarStore } from '../../../../core/stores';
import * as Paths from '../../../../core/constants';
import { AdminReportType, LanguageEnum, Role } from '../../../../core/enums';
import { AdminGenerateReportDialogComponent } from '../admin-scans/admin-generate-report-dialog/admin-generate-report-dialog.component';

@Component({
  standalone: true,
  selector: 'dbx-admin-navbar',
  imports: [TranslateModule, MatMenuModule, MatIcon, RouterLink, MatToolbarModule],
  providers: [NavbarStore],
  templateUrl: 'admin-navbar.component.html',
  styleUrl: 'admin-navbar.component.scss',
})
export class AdminNavbarComponent {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly authStore = inject(AuthStore);
  private readonly store = inject(NavbarStore);
  private readonly dialogService = inject(DialogService);

  authenticated = this.authStore.authenticated;
  $language = this.authStore.language;
  $user = this.authStore.user;

  readonly version = environment.version;
  readonly LanguageEnum = LanguageEnum;
  readonly Role = Role;
  readonly Paths = Paths;

  handleLanguageChange(language: LanguageEnum) {
    this.store.changeCurrentUserLanguage(language);
  }

  logout(): void {
    this.authService.logout().subscribe({
      next: () => this.router.navigate([Paths.LOGIN_PATH]).then(),
      error: () => console.error('Something went wrong!'),
    });
  }

  openGenerateExecutiveReportDialog(): void {
    this.dialogService.openDialog(AdminGenerateReportDialogComponent, {
      reportType: AdminReportType.Executive,
    });
  }

  openGenerateDetailedReportDialog(): void {
    this.dialogService.openDialog(AdminGenerateReportDialogComponent, {
      reportType: AdminReportType.Detailed,
    });
  }
  openGenerateFullReportDialog(): void {
    this.dialogService.openDialog(AdminGenerateReportDialogComponent, {
      reportType: AdminReportType.Full,
    });
  }
}
